import React, { Fragment } from 'react';
import { LinkContainer } from 'react-router-bootstrap';

import Button from 'react-bootstrap/Button';
import Nav from 'react-bootstrap/Nav';

const SigniedOutLinks = () => {
	return (
		<Fragment>
			<Nav>
				<LinkContainer
					to='/home'
					className='bg-btn-web mx-1'
					activeClassName='nav-active'>
					<div>Inicio</div>
				</LinkContainer>
				<LinkContainer
					to='/about'
					className='bg-btn-web mx-1'
					activeClassName='nav-active'>
					<div>Conócenos</div>
				</LinkContainer>
				<LinkContainer
					to='/courses'
					className='bg-btn-web mx-1'
					activeClassName='nav-active'>
					<div>Cursos</div>
				</LinkContainer>
				<LinkContainer
					to='/contact'
					className='bg-btn-web mx-1'
					activeClassName='nav-active'>
					<div>Contáctanos</div>
				</LinkContainer>
			</Nav>
			<Nav style={{ marginLeft: 120 }}>
				<div className='my-2 my-md-0'>
					<LinkContainer to='/signin' className='nav-btn'>
						<Nav.Link>
							<Button
								variant='outline-light'
								block
								className='btn-rounded shadow-sm px-3 py-1'>
								Ingresar
							</Button>
						</Nav.Link>
					</LinkContainer>
				</div>
			</Nav>
		</Fragment>
	);
};

export default SigniedOutLinks;
